<template>
    <div class="onboarding">
        <div class="scroll-point"></div>
        <coffee-quiz
                :questions="questions"
                :question-total="9"
                v-on:answers-changed="onAnswersChanged"
                v-on:complete="onQuizCompleted"
        />

        <onboarding-order-preferences
                v-show="quizCompleted"
                :page-number="9"
                :custom-sizes="customSizes"
                :avg-costs="avgCosts"
                :avg-decaf-costs="decafCosts"
                v-on:submit="onPreferenceSubmitted"
                v-on:reset="onPreferencesReset"
                ref="onboardingPreferenceComponent"
        />

        <!-- "Skip the Quiz" intentionally removed, not just hidden: it linked to
             /users/sign_up, the retired Devise signup form. Signup goes through
             the quiz. See the note where skipQuiz() used to live. -->

        <div class="matching-results-wrapper">
            <transition name="fade-slow" mode="out-in">
                <div v-show="!!orderPreferences" >

                    <div class="matching-results-heading">
                        <transition name="fade-fast" mode="out-in">
                        <div v-if="calculating" key="calculating">
                            <loading-spinner />
                            <h2>Calculating the perfect coffee for you.</h2>
                        </div>
                        <div v-else>
                            <h2 v-if="hasReferral">Let’s take $5 off your first order, and keep it going for the next 7 orders after that.</h2>
                            <h2 v-else-if="messageShow">Let's take Half off on your first order.</h2>
                            <h2 v-else-if="sizeCategory === 'small_size'">Let's take $5 off on your first order </h2>
                            <h2 v-else-if="sizeCategory === 'medium_size'">Let's take $10 off on your first order </h2>
                            <h2 v-else-if="sizeCategory === 'large_size'">Let's take $20 off on your first order </h2>
                        </div>
                        </transition>
                    </div>

                    <transition name="fade-slow" mode="out-in">
                        <div v-if="matchingCoffees" class="margin-top-md">
                            <onboarding-coffee-card-list
                                    :coffees="matchingCoffees"
                                    :buy-now-props="buyNowProps"
                                    :onboarding-quiz-answers="answers"
                                    :order-preferences="orderPreferences"
                                    :custom-sizes="customSizes"
                                    :min-value="min"
                                    :max-value="max"
                            />

                            <!-- This part is for testing the matching algorithm
                            <div style="margin: auto; margin-top: 8rem; text-align: left">
                               <div v-for="a in answers">
                                   {{ a.category }} - {{ a.key }}
                               </div>
                               <table style="margin: auto;">
                                   <tr>
                                       <th>name</th>
                                       <th>score</th>
                                       <th>methods</th>
                                       <th>roast</th>
                                       <th>adventurous</th>
                                       <th>c & s</th>
                                       <th>flavors</th>
                                       <th>acidity</th>
                                       <th>grinds</th>
                                       <th>decaf</th>
                                   </tr>
                                   <tr v-for="coffee in matchingCoffees">
                                       <td>{{coffee.name}}</td>
                                       <td>{{coffee.points}} / {{coffee.max_points}}</td>
                                       <td>{{coffee.brew_methods}}</td>
                                       <td>{{coffee.coffee_roast}}</td>
                                       <td>{{coffee.grading2}}</td>
                                       <td>{{coffee.grading4}}</td>
                                     <td>{{coffee.coffee_flavor}}</td>
                                       <td>{{coffee.grading1}}</td>
                                       <td>{{coffee.grinds}}</td>
                                       <td>{{coffee.decaf}}</td>
                                   </tr>
                               </table>
                            </div> -->
                        </div>
                    </transition>
                </div>
            </transition>
            <div v-if="showval" v-bind:class="!!orderPreferences ? 'price-handler' : 'price-handler-2' ">
                <h4 class="setting-header">Budget per bag:</h4>
                <h4>${{ values[0] / 100 }} - ${{ values[1] / 100 }}</h4>
                <div class="min-max-wrapper">
                    <span class="slider-min-v">Min</span>
                    <span class="slider-max-v">Max</span>
                </div>
               <vue-slider
                    ref="slider"
                    v-model="values"
                    :min="rangeMin"
                    :max="rangeMax"
                    :interval="100"
                    :dot-size="30"
                    :tooltip-placement="'bottom'"
                    :tooltip-formatter="formatter"
                    @change="changePrice"
                    class="price-range-slider">
                </vue-slider>
            </div>
        </div>
    </div>
</template>

<script>
    import CoffeeQuiz from '../coffee-quiz/coffee-quiz-new'
    import OnboardingOrderPreferences from './onboarding-order-preferences'
    import OnboardingCoffeeCardList from './onboaring-coffee-card-list'
    import LoadingSpinner from "../../common/loading-spinner"
    import VueSlider from 'vue-slider-component';
    import 'vue-slider-component/theme/default.css';
    import smoothscroll from 'smoothscroll-polyfill';


    export default {
        components: {
            CoffeeQuiz,
            OnboardingOrderPreferences,
            OnboardingCoffeeCardList,
            LoadingSpinner,
            VueSlider
        },
        props: {
            questions: Array,
            buyNowProps: Object,
            customSizes: Array,
            avgCosts: Array,
            decafCosts: Array
        },
        data: function() {
            return  {
                orderPreferences: undefined,
                matchingCoffees: undefined,
                quizCompleted: false,
                showSkipBtn: true,
                calculating: false,
                messageShow: false,
                sizeCategory: undefined,
                formatter: v => `$${Math.round(v * 0.01)}`,
                values: [],
                min: 0,
                max: 0,
                hasReferral: false,
                showval: undefined
            }
        },
        methods: {
            changePrice(event){
                this.min = event[0];
                this.max = event[1];
                this.showval =  true;
                setTimeout(()=> this.onPreferencesReset(), 2000);
            },
            getReferralCodeCookie() {
              const value = `; ${document.cookie}`;
              const parts = value.split(`; referral_code=`);
              if (parts.length === 2) return true;
              return false;
            },
            onAnswersChanged(answerCount) {
                this.showSkipBtn = answerCount === 0;
            },
            onQuizCompleted(answers) {
                fbq('track', 'Onboarding: Quiz Completed');
                this.quizCompleted = true;
                this.answers = answers;
                this.scrollToOrderPreferences();
                this.onPreferencesReset();
                this.$refs.onboardingPreferenceComponent.isSubscription = false;
                this.$refs.onboardingPreferenceComponent.onOrderOptionSelected();
            },
            onPreferenceSubmitted(preferences) {
                this.orderPreferences = preferences;
                this.calculating = true;
                this.scrollToMatchingResults();
                setTimeout(()=> this.findMatchingCoffees(), 2000); // Give some time so that it looks like calculating hard...
            },
            onPreferencesReset() {
                this.orderPreferences = this.matchingCoffees = undefined;
                this.$refs.onboardingPreferenceComponent.submitted = false;
            },
            findMatchingCoffees() {
                this.calculating = true;
                this.$api.get('v1/coffee_preferences/matching_coffees', this.getMatchingCoffeesParams())
                    .then(res => this.onMatchingCoffeesFound(res.data))
                    .catch(console.error);
            },
            getMatchingCoffeesParams() {
                return {
                    params: {
                        answers: this.answers,
                        grind: this.orderPreferences.grind,
                        type: this.orderPreferences.type,
                        size: this.orderPreferences.size,
                        min: this.min,
                        max: this.max
                    }
                }
            },
            onMatchingCoffeesFound(coffees) {
                this.matchingCoffees = coffees;
                this.showval = true;
                this.messageShow = this.orderPreferences.subscribe;
                this.sizeCategory = this.orderPreferences.sizecategory;
                this.calculating = false;
            },
            scrollToQuiz() {
                const elem = this.$el.getElementsByClassName('scroll-point')[0];
                this.autoScroll(elem);
            },
            scrollToOrderPreferences() {
                const elem = this.$el.getElementsByClassName('order-preference-scroll-point')[0];
                setTimeout(() => this.autoScroll(elem), 1500);
            },
            scrollToMatchingResults() {
                const elem = this.$el.getElementsByClassName('matching-results-wrapper')[0];
                this.autoScroll(elem);
            },
            // skipQuiz() removed. It sent people to /users/sign_up -- the old Devise
            // registration form, which created an account from an email and a
            // password alone: no address, no payment method, no enforced
            // reCAPTCHA. That form is gone and /users/sign_up now redirects to
            // /onboarding, so this would have bounced the user straight back to
            // the quiz they were trying to skip.
            //
            // Its trigger (`<a @click="skipQuiz()">Skip the Quiz</a>`) was already
            // commented out of the template above, so nothing called this. It is
            // deleted rather than left dead so that re-enabling that link cannot
            // silently resurrect a dead end. Every account now comes through the
            // quiz.
            autoScroll(elem) {
                if (elem) {
                    elem.scrollIntoView({behavior: 'smooth'});
                }
            },
        },
        computed: {
            grindSelected: function() {
                return this.orderPreferences.grind;
            },
            rangeMin() {
                this.values=[];
                if (this.sizeCategory === "small_size"){
                    this.values = [1500, 2600];
                    return 1500
                }else if (this.sizeCategory === "medium_size"){
                    this.values = [2500, 6500];
                    return 2500
                }else if (this.sizeCategory === "large_size"){
                    this.values= [4000, 13000];
                    return 4000
                }
                this.values=[];
            },
            rangeMax() {
                if (this.sizeCategory === "small_size"){
                    return 5000
                }else if (this.sizeCategory === "medium_size"){
                    return 7500
                }else if (this.sizeCategory === "large_size"){
                    return 15000
                }
            }
        },
        mounted() {
            this.hasReferral = this.getReferralCodeCookie();
            smoothscroll.polyfill();
            setTimeout(this.scrollToQuiz, 3000);
        }
    }
</script>

<style lang="scss">
    @import "../../../styles/_variables_home.scss";
    @import "../../../styles/common_home.scss";

    .onboarding {
        margin-top: 3rem;
        padding-bottom: 200px;
        text-align: center;
    }
    .matching-results-wrapper {
        padding-top: 100px;
        h2 {
            padding: 0 20px;
        }
    }
    .matching-results-heading {
        // Background image is set in /app/assets/stylesheets/onboarding.less
        padding: 13rem 0;
        h2 {
            margin-top: 2.5rem;
            padding: 0 3rem;
        }
    }
    .scroll-point {
        visibility: hidden;
        position: relative;
        top: -100px;
    }
    .skipQuiz {
        display: inline-block;
        cursor: pointer;
        line-height: 2;
        margin-top: 0.25rem;
    }
    .price-range-slider {
        margin-bottom: 2rem;
        max-width: 400px !important;
        margin: 0 auto !important;
    }
    .vue-slider {
        margin-left: 1rem;
        margin-right: 1rem;
        max-width: 500px;
    }
    .vue-slider-process {
        background-color: #50784F;
    }
    .vue-slider-dot-tooltip-inner {
        color:#50784F;
        font-weight: bold !important;
        font-size: 20px;
        background-color: transparent;
        border-color: transparent;
    }
    .vue-slider-dot-handle {
        background-color: #50784F;
    }

    .vue-slider-rail {
        height: 14px;
    }
    .min-max-wrapper {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }
    .min-max-wrapper  span {
        font-size: 20px;
        font-weight: 600;
    
    }
    .price-handler {
        max-width: 434px;
        margin: 0 auto;
    }
    .price-handler h4:last-of-type {
        position: relative;
        bottom: -17px;
        margin-bottom: 0;
        margin-top: 0;
    }
    .price-handler h4.setting-header {
        margin-bottom: 0;
    }
    .price-handler-2{
        max-width: 434px;
        margin: -70px auto;
        h4:last-of-type {
            position: relative;
            bottom: -17px;
            margin-bottom: 0;
            margin-top: 0;
        }
        h4.setting-header {
            margin-bottom: 0;
        }
    }

    @media only screen and (max-width: $max-tablet-width) {
    }
</style>
